import { Callout } from '@/components/notifications/Callout/Callout';

import { useHypotheticalTransferCallout } from '../hooks/useHypotheticalTransferCallout';

export function TransferTypeCallout() {
  const { severity, message } = useHypotheticalTransferCallout();

  if (!severity || !message) {
    return null;
  }

  return <Callout severity={severity}>{message}</Callout>;
}
